import { atom } from "recoil";

export const activeTabReservationsPatientState = atom({
    key: 'activeTabReservationsPatient',
    default: "1"
})

export const cancelReservationExecuteState = atom({
    key: 'cancelReservationExecute',
    default: false
});

export const showModalCancelReservationState = atom({
    key: 'showModalCancelReservation',
    default: false
})

export const reservationForCancelSelectedState = atom({
    key: 'reservationForCancelSelected',
    default: null
})